// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Panel.css
// module id = 1169
// module chunks = 0 1 2